var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { loop, isLoop, getModel, getCmd } from './loop';
import Cmd from './cmd';

export default function mergeChildReducers(parentResult, action, childMap) {
  var initialState = parentResult,
      parentCmd = void 0;
  if (isLoop(initialState)) {
    parentCmd = getCmd(initialState);
    initialState = getModel(initialState);
  }

  var cmds = parentCmd ? [parentCmd] : [];
  var hasChanged = false;

  var newState = Object.keys(childMap).reduce(function (prev, key) {
    var childReducer = childMap[key];
    if (!childReducer) {
      if (!hasChanged) {
        prev = _extends({}, prev);
        hasChanged = true;
      }
      delete prev[key];
      return prev;
    }
    var currentChild = childReducer(prev[key], action);
    if (isLoop(currentChild)) {
      cmds.push(getCmd(currentChild));
      currentChild = getModel(currentChild);
    }

    if (prev[key] !== currentChild && hasChanged) {
      prev[key] = currentChild;
    } else if (prev[key] !== currentChild) {
      prev = _extends({}, prev, _defineProperty({}, key, currentChild));
      hasChanged = true;
    }
    return prev;
  }, initialState);

  return loop(newState, getListCmdIfNeeded(cmds));
}

function getListCmdIfNeeded(cmds) {
  switch (cmds.length) {
    case 0:
      return Cmd.none;
    case 1:
      return cmds[0];
    default:
      return Cmd.list(cmds);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-loop/es/merge-child-reducers.js
// module id = 92
// module chunks = 0